import { CommonModule } from '@angular/common';
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormsServiceService } from '../../../api/services/forms-service.service';

@Component({
    selector: 'app-domain-input',
    imports: [CommonModule, FormsModule, ReactiveFormsModule],
    templateUrl: './domain-input.component.html',
    styleUrl: './domain-input.component.css'
})
export class DomainInputComponent {
  domainInput: string = '';
  inputWithTags: any;
  @Input() formGroup!: FormGroup;
  @Input() fields: any;
  @Input() autoFocused: any;
  showError: string = '';
  errors: { [key: string]: string } = {};
  @Output() apiValidationError = new EventEmitter<boolean>();
  @ViewChild('focusInput') focusInput!: ElementRef<HTMLInputElement>;
  constructor(private formService: FormsServiceService) {}
  ngOnChanges() {
    if (!this.autoFocused) return;

    setTimeout(() => {
      this.focusInput?.nativeElement.focus();
    });
  }
  addDomainFromControl(inputRef: HTMLInputElement): void {
    // ✅ Convert to lowercase immediately
    const domain = inputRef.value?.trim()?.toLowerCase();
    const control = this.formGroup.get(this.fields.fieldName);

    // Get regex from validationRules
    const regexRule = this.fields.validationRules?.find(
      (v: any) => v.type.toLowerCase() === 'regex',
    );
    const domainRegex = regexRule ? new RegExp(regexRule.value) : null;

    if (!domain) return;

    this.showError = '';

    // ✅ Validate regex using lowercase value
    if (domainRegex && !domainRegex.test(domain)) {
      this.showError = regexRule?.error || 'Invalid domain format.';
      return;
    }

    // ✅ API check (lowercase value sent)
    const payload = {
      formId: this.fields.formId,
      fields: ['name', 'domain', 'subnodes.domain'],
      value: domain, // already lowercase
    };

    this.formService.fieldAvailabilityChecker(payload).subscribe({
      next: (res: any) => {
        if (res.success) {
          // ✅ Store lowercase string
          this.inputWithTags = domain;
          // control?.setValue(domain);
          this.showError = '';
          this.apiValidationError.emit(false);
        }
      },
      error: (err) => {
        if (err.error?.data?.exists) {
          this.showError = err.error.message || 'Domain already exists';
          this.apiValidationError.emit(true);
        }
      },
    });
  }

  showErrorMessage(): boolean {
    const control = this.formGroup.get(this.fields.fieldName);
    if (!control) return false;

    if (control.hasError('required') && !this.inputWithTags?.trim()) {
      this.showError = 'Please add at least one domain';
      return false;
    }

    if (control.hasError('pattern') && control.dirty) {
      const regexRule = this.fields.validationRules?.find(
        (v: any) => v.type.toLowerCase() === 'regex',
      );
      this.showError = regexRule?.error || 'Invalid format.';
      return false;
    }

    this.showError = '';
    return true;
  }

  /** Function to show the validation error message on enter of the text */
  onKeyUpValidateFields(field: any): void {
    const fieldName = field.fieldName;
    const control = this.formGroup.get(fieldName);
    if (!control) return;
    control.markAsTouched();
    control.updateValueAndValidity({ emitEvent: false });
    this.errors[fieldName] = '';

    if (control.hasError('pattern')) {
      const regexRule = field.validationRules?.find(
        (v: any) => v.type.toLowerCase() === 'regex',
      );
      this.errors[fieldName] = regexRule?.error || 'Invalid format.';
      return;
    }

    this.errors[fieldName] = '';
  }
}
